import React from 'react'

function AppDetails() {
  return (
    <div>AppDetails</div>
  )
}

export default AppDetails